// @ts-nocheck







import CommonApi from '../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';
import { fetchRequest } from './index';

export const convertDataToServer = (
driverInspectionCalculation) => (
{
  ...driverInspectionCalculation,
  sum: convertFromRubToKop(driverInspectionCalculation.sum),
  months: driverInspectionCalculation.months.map(convertDataToServerMonth)
});

export const convertDataFromServer = (
driverInspectionCalculation) => (
{
  ...driverInspectionCalculation,
  sum: convertFromKopToRub(driverInspectionCalculation.sum),
  months: driverInspectionCalculation.months.map(convertDataFromServerMonth)
});

export const convertDataToServerMonth = (
driverInspectionCalculationMonth) => (
{
  ...driverInspectionCalculationMonth,
  cost: convertFromRubToKop(driverInspectionCalculationMonth.cost)
});

export const convertDataFromServerMonth = (
driverInspectionCalculationMonth) => (
{
  ...driverInspectionCalculationMonth,
  cost: convertFromKopToRub(driverInspectionCalculationMonth.cost)
});

const basedUrl = 'driverInspectionCalculation';
const driverInspectionCalculation = new CommonApi(
  basedUrl,
  'расчет потребности в предрейсовых/послерейсовых осмотрах водителей',
  convertDataToServer,
  convertDataFromServer
);

const calculate = async (vehiclePlanId) => {
  const updated = await fetchRequest.put(
    `/${basedUrl}/calculate/${vehiclePlanId}`
  );
  if (updated) return updated;
  throw new Error(`Не удалось произвести расчет`);
};

const changeStatus = async (
vehiclePlanId,
status) =>
{
  const updated = await fetchRequest.put(`/${basedUrl}/changeStatus`, {
    vehiclePlanId,
    status
  });
  if (updated) return updated;
  throw new Error(`Не удалось сменить статус`);
};

export default {
  ...driverInspectionCalculation,
  calculate,
  changeStatus
};
